/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, Text, xcss } from '@atlaskit/primitives';

import { BrandHeading } from '../brand-heading';

import { BlogInfo } from './blog-info';
import type { BlogMeta } from './types';

const rootStyles = xcss({
	borderBlockEndStyle: 'solid',
	borderBlockEndWidth: 'border.width',
	borderBlockEndColor: 'color.border',
	paddingBlockEnd: 'space.200',
});

export const BlogHeader = ({ meta }: { meta: BlogMeta }) => {
	return (
		<Stack xcss={rootStyles} space="space.200">
			<BrandHeading as="h2" size="xxlarge">
				{meta.title}
			</BrandHeading>
			<Text size="large">{meta.description}</Text>
			<BlogInfo meta={meta} />
		</Stack>
	);
};
